module.exports = __webpack_public_path__ + "img/alex-tampi_bottom.6fe11aca.png";